import { Loggable } from '@rbi-ctg/frontend';
import { StatusType, dataDogLogger } from 'utils/datadog';

type CtLinkingPhase = 'initiate-linking' | 'complete-linking';

/**
 * Emits one structured Datadog log per partner-linking outcome (RP-Site view)
 * so the front-channel funnel is observable alongside the th-loyalty
 * back-channel logs: `info` for happy-path outcomes, `warn` for the
 * rate-limit cap, `error` for every failure branch. `dataDogLogger` attaches
 * the authed `userId` (cognitoId), which correlates with the gateway logs.
 *
 * `phase` distinguishes the initiate (redirect) and complete (OIDC callback)
 * legs of the flow in the log `message`.
 *
 * `bypassSampling: true` opts these logs out of the session-based Datadog log
 * sampling (`datadogLogSampleRate`). Without it, the whole funnel is invisible
 * in the ~99% of sessions that sampling drops — unacceptable for a low-volume
 * flow where every outcome matters. Volume is one log per linking attempt.
 */
export function makeCtLinkingLogger(phase: CtLinkingPhase) {
  return function logCtLinking(
    event: string,
    status: StatusType,
    context: Record<string, Loggable> = {}
  ): void {
    dataDogLogger({
      message: `CT ${phase}: ${event}`,
      status,
      bypassSampling: true,
      context: { feature: 'partner-linking', partnerId: 'CT', event, ...context },
    });
  };
}
